/** Mirrors Platform report admission. It never changes collection or enables analysis. */
export const REPORT_CADENCES = ['per_update', 'daily', 'weekly'] as const;
export type MarketReportCadence = typeof REPORT_CADENCES[number];
export interface MarketReportConfig {
    schema_version: 'market-report-config/v1';
    cadence: MarketReportCadence;
}

export function normalizeReportConfig(value: unknown): MarketReportConfig {
    if (!value || typeof value !== 'object' || Array.isArray(value)) throw new Error('Invalid report schedule');
    const input = value as Record<string, unknown>;
    if (Object.keys(input).length !== 2 || input.schema_version !== 'market-report-config/v1'
        || !REPORT_CADENCES.includes(input.cadence as MarketReportCadence)) throw new Error('Invalid report schedule');
    return { schema_version: 'market-report-config/v1', cadence: input.cadence as MarketReportCadence };
}

export function reportConfigWrite(cadence: MarketReportCadence | undefined): MarketReportConfig | undefined {
    return cadence === undefined ? undefined : normalizeReportConfig({ schema_version: 'market-report-config/v1', cadence });
}

export function validReportConfig(value: unknown): boolean {
    if (value === undefined) return true;
    try { normalizeReportConfig(value); return true; } catch { return false; }
}

export function reportConfigMatches(requested: unknown, echoed: unknown): boolean {
    if (requested === undefined) return true; // Omitted edits do not replace a saved schedule.
    try { return normalizeReportConfig(requested).cadence === normalizeReportConfig(echoed).cadence; }
    catch { return false; }
}
